import { Link } from 'react-router-dom';

import PropertyVisual from '../components/PropertyVisual';
import { useLanguage } from '../context/LanguageContext';
import { saleListings } from '../data/sales';

function numericFact(value) {
  return String(value).match(/\d+(?:[.,]\d+)?/)?.[0] ?? value;
}

function SalePage() {
  const { language } = useLanguage();

  const copy = language === 'ru'
    ? {
        eyebrow: 'Недвижимость в Святом‑Стефане',
        title: 'Апартамент в продаже',
        lead: 'Готовый апартамент в Adriatic Masterpiece Residence. Подробная информация об объекте и условиях покупки предоставляется по запросу.',
        apartment: 'Апартамент',
        area: 'Площадь',
        bedrooms: 'Спальни',
        bathrooms: 'Санузлы',
        view: 'Смотреть объект',
      }
    : {
        eyebrow: 'Property in Sveti Stefan',
        title: 'Apartment for sale',
        lead: 'A completed apartment at Adriatic Masterpiece Residence. Full property details and purchase terms are available on request.',
        apartment: 'Apartment',
        area: 'Area',
        bedrooms: 'Bedroom',
        bathrooms: 'Bathroom',
        view: 'View property',
      };

  return (
    <section className="page-shell sale-page">
      <header className="page-intro page-intro_left sale-page__intro">
        <span className="eyebrow">{copy.eyebrow}</span>
        <h1>{copy.title}</h1>
        <p>{copy.lead}</p>
      </header>

      <div className={`sale-grid ${saleListings.length === 1 ? 'sale-grid_single' : ''}`}>
        {saleListings.map((listing) => {
          const residence = listing.residence;
          const [area, bedrooms, bathrooms] = residence.specs[language].slice(1);

          return (
            <article className="sale-card" key={listing.apartmentNumber}>
              <Link
                className="sale-card__visual"
                to={`/sale/${listing.apartmentNumber}`}
                aria-label={`${copy.apartment} ${listing.apartmentNumber}: ${residence.name[language]}`}
              >
                <PropertyVisual src={residence.image} alt={residence.name[language]} />
                <span className="sale-card__number">№ {listing.apartmentNumber}</span>
              </Link>

              <div className="sale-card__body">
                <div className="sale-card__heading">
                  <div>
                    <span className="eyebrow">{copy.apartment} № {listing.apartmentNumber} · {listing.floor[language]}</span>
                    <h2>{residence.name[language]}</h2>
                  </div>
                </div>

                <p>{listing.lead[language]}</p>

                <dl className="sale-card__facts">
                  {[
                    [copy.area, area],
                    [copy.bedrooms, numericFact(bedrooms)],
                    [copy.bathrooms, numericFact(bathrooms)],
                  ].map(([label, value]) => (
                    <div key={label}>
                      <dt>{label}</dt>
                      <dd>{value}</dd>
                    </div>
                  ))}
                </dl>

                <div className="sale-card__footer">
                  <strong>{listing.price[language]}</strong>
                  <Link className="text-link" to={`/sale/${listing.apartmentNumber}`}>{copy.view} <span>↗</span></Link>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default SalePage;
